export default __webpack_public_path__ + "static/media/patrick_mcgorry.47a4a89c.jpg";